import { AlignmentType, HeadingLevel, Paragraph, TabStopType, TextRun, WidthType } from "docx";


export const Recommendations = new Paragraph({
    alignment: AlignmentType.LEFT,
    spacing: { before: 150, after: 100, },

    children: [
        new TextRun({
            text: "9.  Detailed Stage 1 Findings and Recommendations",
            size: 22,
            color: "C00000",
            font: "Cambria (Headings)",
            bold: true,
            italics: false,
            allCaps: false
        })
    ],
    heading: HeadingLevel.HEADING_2,
})

export const stageText1 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 450, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "This section of the report provides mitigation steps for the identified vulnerabilities.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})

export const stageText2 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 50, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "The tables below list the vulnerabilities identified, their rating and the remediation actions to be performed. The scale as mentioned in Section 7.0 has been used to rate the severity.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})


export const stageText3 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 250, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "The remediation measures that are listed below should not be implemented on the production systems without prior testing and processing through the proper change management process.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false,
            bold: true
        }),
    ],
})